export default "__VITE_ASSET__Jl1SQGlY__"